var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "py-2 title" },
        [
          _c("v-icon", { staticClass: "mr-2" }, [_vm._v("assignment")]),
          _vm._v(" "),
          _c("div", { staticClass: "title info--text" }, [
            _vm._v("Information"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          "disable-initial-sort": "",
          "hide-headers": "",
          "hide-actions": "",
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item, index }) {
              return [
                _c("tr", { class: { alternate: index % 2 == 0 } }, [
                  _c("td", { staticClass: "text-xs-left font-weight-medium" }, [
                    _vm._v(_vm._s(item.Field)),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-xs-left" }, [
                    _vm._v(_vm._s(item.FieldValue)),
                  ]),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }